import styled from 'styled-components';
import {Box} from "@mui/material";

export const LicenseManagementHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
`;

export const HeaderTitleBox = styled(Box)`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 16px;
`;
